// extracted by mini-css-extract-plugin
module.exports = {"answerItem":"styles_answerItem__LEstC","answerImg":"styles_answerImg__j6fbp","answerCopy":"styles_answerCopy__fSIRq"};